export default "__VITE_ASSET__CJCqqzHk__"